import { CheckCircle as CheckIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';

interface FooterActionsProps {
  onFinish: () => void;
  onGoToStart: () => void;
  isProcessing: boolean;
}

const FooterActions = ({ onGoToStart, isProcessing }: FooterActionsProps) => {
  return (
    <div className='w-full md:w-auto flex gap-4'>
      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        action={onGoToStart}
        disabled={isProcessing}
        size='large'
      >
        <CheckIcon className='mr-2 text-[18px]' />
        Confirmar
      </GlobalButton>
    </div>
  );
};

export default FooterActions;
